import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Layout, SharedHero } from '../../v2/components/common';
import {
  CaseStudy,
  Info,
  TransformBusiness,
} from '../../v2/components/prosNewConstruction';
import { URLS } from '../../v2/constants';

const NewConstructionSolution: React.FC = () => (
  <Layout title="New construction" buttonType="CHAT_WITH_A_REP">
    <SharedHero
      heading="Use HOVER for new construction jobs"
      body="The fastest, simplest way to get measurements and prepare standout bids from blueprints. Turn it on for your account today."
      chatWithUsLink={URLS.newConstructionSolution.chatWithUs}
      openModalButtonTitle="TRY IT NOW"
      openModalButtonLink="https://hover.to/login"
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="invited by contractor hero"
          src="../../v2/assets/images/new_construction_solution_hero_desktop.png"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          alt="invited by contractor hero"
          src="../../v2/assets/images/new_construction_solution_hero_tablet.png"
        />
      }
    />

    <Info />
    <CaseStudy />
    <TransformBusiness />
  </Layout>
);

export default NewConstructionSolution;
